(() => {
  if (window.EthnicWishDeliveryEstimate) {
    window.EthnicWishDeliveryEstimate.refresh();
    return;
  }
  let timer;
  const refresh = () => {
    clearTimeout(timer);
    const now = new Date();
    const locale = document.documentElement.lang || 'en';
    document.querySelectorAll('[data-delivery-estimate]').forEach(node => {
      const min = Number(node.dataset.minDays);
      const max = Number(node.dataset.maxDays);
      if (!Number.isInteger(min) || !Number.isInteger(max) || min < 0 || max < min || max > 60) return;
      const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() + min, 12);
      const end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + max, 12);
      const options = { day: 'numeric', month: 'short' };
      if (start.getFullYear() !== now.getFullYear() || end.getFullYear() !== now.getFullYear()) options.year = 'numeric';
      const formatter = new Intl.DateTimeFormat(locale.startsWith('en') ? 'en-GB' : locale, options);
      const iso = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      const first = document.createElement('time');
      first.dateTime = iso(start);
      first.textContent = formatter.format(start);
      const last = document.createElement('time');
      last.dateTime = iso(end);
      last.textContent = formatter.format(end);
      node.querySelector('[data-delivery-dates]')?.replaceChildren(first, document.createTextNode(` ${node.dataset.dateSeparator || '–'} `), last);
    });
    if (document.querySelector('[data-delivery-estimate]')) {
      const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      timer = setTimeout(refresh, midnight.getTime() - now.getTime() + 1000);
    }
  };
  window.EthnicWishDeliveryEstimate = { refresh };
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  window.addEventListener('pageshow', refresh);
  refresh();
})();
